import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function VisitTheEstate() {
  return <section data-section-id="223841" id="visit-the-estate" className="relative w-full bg-background text-foreground overflow-hidden min-h-[80vh] flex items-center py-20 lg:py-0">
      {}
      <div className="absolute top-0 right-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/4 w-[800px] h-[800px] lg:w-[1200px] lg:h-[1200px] opacity-10 text-secondary">
          <path fill="currentColor" d="M45.7,-76.4C58.9,-69.3,69.1,-55.3,76.5,-40.4C83.9,-25.5,88.5,-9.7,86.2,5.3C83.9,20.3,74.7,34.6,63.7,46.1C52.7,57.6,39.9,66.3,25.6,71.7C11.3,77.1,-4.5,79.2,-19.7,76.3C-34.9,73.4,-49.5,65.5,-61.2,54.1C-72.9,42.7,-81.7,27.8,-85.1,11.8C-88.5,-4.2,-86.5,-21.3,-78.2,-35.5C-69.9,-49.7,-55.3,-61,-40.4,-67.6C-25.5,-74.2,-10.3,-76.1,3.2,-80.6C16.7,-85.1,32.5,-83.5,45.7,-76.4Z" transform="translate(100 100) scale(1.1)" />
        </svg>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div className="lg:col-span-7 flex flex-col items-start space-y-8 relative z-20 order-2 lg:order-1">
            <div className="space-y-6 max-w-2xl">
              <h1 className="font-default text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-bold text-primary leading-[1.1] tracking-tight">
                Experience the Velvet Touch
              </h1>
              <p className="font-default text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-xl">
                Step into a world where time slows down. Our tasting room offers a sanctuary of warmth and elegance, where the sunlight dances across aged oak and every pour tells a story of our heritage.
              </p>
            </div>
            
            <div className="pt-4">
              <Link to="/TastingToursPage">
                <Button size="lg" className="bg-primary text-primary-foreground hover:bg-secondary rounded-md px-8 h-14 text-lg font-medium transition-all duration-300 ease-out hover:scale-105 hover:shadow-lg hover:shadow-primary/20">
                  Book a Tasting Tour
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative z-10 flex justify-center lg:justify-end order-1 lg:order-2">
            <div className="relative w-full max-w-md lg:max-w-none">
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683378/img/tasting_room_interior_sunlight.png" alt="Warm and inviting tasting room interior with sunlight" className="w-full h-auto object-contain rounded-md shadow-2xl lg:-ml-32 lg:w-[130%] max-w-none relative z-10" style={{
              filter: "drop-shadow(0 25px 25px rgb(0 0 0 / 0.15))"
            }} />
            </div>
          </div>

        </div>
      </div>
    </section>;
}